import { buttonType } from "components/Button/Button";
import React, { Fragment, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { colors } from "theme/Theme";
import PartnersGrid from "./PartnersGrid";
import Button from "components/Button";
import { device, toRem } from "theme/Breakpoints";
import { defaultHorizontalMargin, defaultVerticalPadding, shadow } from "theme/GlobalElements";
import { useWindowDimensions } from "hooks/useWindowDimensions";
import { useNavigate } from "react-router-dom";

interface PartnersProps {}
type Size = {
  width: string;
  left: string;
};
const Partners: React.FC<PartnersProps> = ({}) => {
  const resize = useWindowDimensions();
  const containerRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  const [size, setSize] = useState<Size>({ width: "0px", left: "0px" });

  useEffect(() => {
    if (containerRef.current) {
      let parentWidth = containerRef.current.offsetWidth;
      let bodyWidth = document.body.offsetWidth;
      let _size: Size = {
        width: `${bodyWidth}px`,
        left: `-${(bodyWidth - parentWidth) / 2}px`,
      };
      setSize(_size);
    }
  }, [resize]);

  const viewAll = () => {
    navigate(`/category`);
  };

  return (
    <PartnersContainer ref={containerRef}>
      <Background size={size} />
      <InnerContainer>
        <h3>Водещи марки</h3>
        <PartnersGrid />
        <ButtonContainer>
          <Button onClick={viewAll} title="Виж всички" type={buttonType.blueBtn} classNames="order-button" />
        </ButtonContainer>
      </InnerContainer>
    </PartnersContainer>
  );
};

const PartnersContainer = styled.div`
  position: relative;
  z-index: 1;
  margin: 30px 0;
  background-color: ${colors.newGray};

  /* @media only screen and (${device.laptop}) {
    margin: 60px 0;
  }

  @media only screen and (${device.desktop}) {
    margin: 80px 0;
  } */
`;

const InnerContainer = styled.div`
  ${defaultHorizontalMargin};
  display: flex;
  flex-direction: column;
  padding-top: ${toRem(10)};
  padding-bottom: ${toRem(10)};

  @media only screen and (${device.tablet}) {
    padding-top: ${toRem(30)};
    padding-bottom: ${toRem(30)};
  }
`;

const ButtonContainer = styled.div`
  max-width: 200px;
`;

const Background = styled.div<{ size: Size }>`
  z-index: -1;
  top: 0;
  bottom: 0;
  width: ${(props) => props.size.width};
  left: ${(props) => props.size.left};
  position: absolute;
  background-color: ${colors.newGray};
`;

export default Partners;
